import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";

import { enterCompetition, patchEntry, patchProfile } from "../../../api";
import useCompetition, {
  useCompetitionEntry,
} from "../../../hooks/useCompetition";
import useErrorAlert from "../../../hooks/useErrorAlert";
import useProfileForm, {
  ProfileValues,
} from "../../../modules/onboarding/components/hooks/useProfileForm";
import getGenericErrorInfo from "../../../utils/getGenericErrorInfo";

export default function useEditEntryScreen() {
  const { setError } = useErrorAlert();
  const { competitionUUID, userUUID } = useParams();

  const { competition } = useCompetition(competitionUUID);
  const { entry } = useCompetitionEntry({ competitionUUID, userUUID });

  const { schema, initialValues } = useProfileForm({
    profile: entry?.user,
    competition,
    previousCategoryUUID: entry?.category?.uuid,
    withCompetitorNumber: false,
  });

  const navigate = useNavigate();

  const onSubmit = async ({ firstName, lastName, category }: ProfileValues) => {
    // try {
    await Promise.all([
      patchProfile({ firstName, lastName, uuid: userUUID }),
      patchEntry({ userUUID, categoryUUID: category, competitionUUID }),
    ]);
    navigate("..");
    // } catch (err) {
    //   setError(getGenericErrorInfo(err));
    // }
  };

  return { competition, entry, schema, initialValues, onSubmit };
}
